import { render, staticRenderFns } from "./quote-table.vue?vue&type=template&id=33fde016&scoped=true"
import script from "./quote-table.vue?vue&type=script&lang=js"
export * from "./quote-table.vue?vue&type=script&lang=js"
import style0 from "./quote-table.vue?vue&type=style&index=0&id=33fde016&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33fde016",
  null
  
)

export default component.exports